import AnalyticsWebClient, { originType } from '@atlassiansox/analytics-web-client';

import { getIdentityEnv, getMappedEnv } from '@atlassian/atlassian-studio-env-utils';
import { isStudioV2 } from '@atlassian/atlassian-studio-routing';

const env = getMappedEnv();
const product = 'atlassianStudio';
const version = isStudioV2() ? 'v2' : 'v1';

const getGasApiHost = () => {
	const currentDomain = window.location.hostname;

	switch (env) {
		case 'staging':
			return 'team.stg.atlassian.com/gateway/api/gasv3/api/v1';
		case 'production':
			return `${currentDomain}/gateway/api/gasv3/api/v1`;
		case 'test':
		case 'local':
			return 'team.stg.atlassian.com/gateway/api/gasv3/api/v1';
		default:
			return 'team.stg.atlassian.com/gateway/api/gasv3/api/v1';
	}
};

export const initAnalyticsClient = () => {
	return new AnalyticsWebClient(
		{
			env: getIdentityEnv(),
			origin: originType.WEB,
			product,
			subproduct: originType.WEB,
			version,
		},
		{
			apiHost: getGasApiHost(),
			// https://hello.atlassian.net/wiki/spaces/policy/pages/3303839825/Onboarding+a+Product+to+the+Cookies+Library+atlassian+browser-storage-controls#Upgrade-Analytics-Client-version-and-include-disableCookiePersistence-variable
			disableCookiePersistence: true,
		},
	);
};

export enum UIActionSubject {
	PICKER = 'picker',
}

export enum Action {
	CLICKED = 'clicked',
	OPENED = 'opened',
	SEARCH = 'searched',
	PAGINATE = 'paginated',
	SELECTED = 'selected',
}

export type ActionSubject = string;

export const getTrackEventName = (actionSubject: ActionSubject, action: Action) =>
	`${actionSubject} ${action}`;

export const getUIEventName = (actionSubject: UIActionSubject, action: Action) =>
	`${actionSubject} ${action}`;
